/** Used in contenetful to set pre-defined possible answers */
import { TFunction } from 'i18next';
import { TherapyTarget } from 'domains/signup/data/types';

const QUESTION_SEPARATOR = '/';

export const splitQuestionAnswers = (possibleAnswers: string) => {
  return possibleAnswers.split(QUESTION_SEPARATOR);
};

export const getTargetMilestoneText = (screenerTitle: string, t: TFunction) =>
  t('screener.results.questions.milestones.targetMilestone', {
    age: screenerTitle,
  });

export const getSortedMilestones = (possibleAnswers: string[], targetMilestoneAnswer: string) => {
  if (possibleAnswers[0] === targetMilestoneAnswer) {
    return possibleAnswers.reverse();
  }
  return possibleAnswers;
};

export const getQuestionTitle = (explanationTitle: string, target: TherapyTarget, answer: string, t: TFunction) => {
  const answerWord = t(`screener.results.questions.questionTitle.answer.${target}.${answer}`);

  return t(`screener.results.questions.questionTitle.${target}`, { answer: answerWord, question: explanationTitle });
};
